var _symbol, _symbol2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecorIconSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "alert-info-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.39999C6.69806 2.39999 2.39999 6.69806 2.39999 12C2.39999 17.3019 6.69806 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69806 17.3019 2.39999 12 2.39999ZM12 5.99999C10.9636 5.99999 10.1675 6.91792 10.314 7.94389L10.8793 11.9008C10.959 12.4585 11.4366 12.8727 12 12.8727C12.5633 12.8727 13.041 12.4585 13.1207 11.9008L13.6859 7.94389C13.8325 6.91792 13.0364 5.99999 12 5.99999ZM12 16.8C12.8133 16.8 13.4727 16.1406 13.4727 15.3273C13.4727 14.5139 12.8133 13.8545 12 13.8545C11.1866 13.8545 10.5273 14.5139 10.5273 15.3273C10.5273 16.1406 11.1866 16.8 12 16.8Z",
    fill: "currentColor"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock-info-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14V16M8 10V6C8 4.34315 9.34315 3 11 3H13C14.6569 3 16 4.34315 16 6V10M6 20H18C19.1046 20 20 19.1046 20 18V12C20 10.8954 19.1046 10 18 10H6C4.89543 10 4 10.8954 4 12V18C4 19.1046 4.89543 20 6 20Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorIconSprite);
export default __webpack_public_path__ + "static/media/decor-icon-sprite.8c81539c629adb10dc01cdaa6d83ef91.svg";
export { ForwardRef as ReactComponent };